import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class HttpHeadersInterceptor implements HttpInterceptor {

 intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
     const token = window.localStorage.getItem('dematral_token');
     const headers: Record<string, string> = {
       'Content-Type': 'application/json'
     };
     const isAuthRequest = request.url.includes('/auth/');
     if (token && !isAuthRequest) {
       headers['Authorization'] = `Bearer ${token}`;
     }
     request = request.clone({ setHeaders: headers });
   return next.handle(request);
 }
}
